// extracted by mini-css-extract-plugin
export default {"root":"OrderTableList_root__ngdtR","loading":"OrderTableList_loading__BiAnf","footer":"OrderTableList_footer__eQK2c"};